module.exports = __webpack_public_path__ + "assets/img/banner2.87489dc5.png";